import { render } from "./AdminWrapPage.vue?vue&type=template&id=5dfda1b6&scoped=true"
import script from "./AdminWrapPage.vue?vue&type=script&lang=js"
export * from "./AdminWrapPage.vue?vue&type=script&lang=js"

import "./AdminWrapPage.vue?vue&type=style&index=0&id=5dfda1b6&lang=scss&scoped=true"
import "./AdminWrapPage.vue?vue&type=style&index=1&id=5dfda1b6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dfda1b6"]])

export default __exports__